
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleUp,
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(faAngleDown, faAngleUp, faCheckCircle, faTimesCircle);

@Component({
  filters: {
    formatDate(val: any) {
      let date: any = val;
      if (moment(date).isValid()) {
        date = moment(date).format('HH:mm');
      }
      return date;
    }
  },
})
export default class WaitingItem extends Vue {
  @Prop(String) type!: string;
  @Prop(Array) data!: Array<any>;

  visible: boolean = true;

  fieldsSet = [
    {
      key: 'waitingNo',
    },
    {
      key: 'name',
    },
    {
      key: 'pax',
    },
    {
      key: 'action',
    },
  ];

  get getTitle() {
    if (this.type === 'waiting') {
      return 'Groups in the waiting list';
    }
    if (this.type === 'seats') {
      return 'Groups Seated';
    }
    if (this.type === 'canceled') {
      return 'Groups Canceled';
    }
  }

  changeStatus(id, status) {
    this.$emit('update', id, status);
  }
}
